export function parseDealName(sourceNotes) {
  if (!sourceNotes) return null;
  const match = sourceNotes.match(/^Name:\s*(.+)$/m);
  return match ? match[1].trim() : null;
}
